(() => {
  const root = document.querySelector('.ar-product');
  const buy = root?.querySelector('.pdp-buy');
  if (!root || !buy || root.dataset.landscapeReady) return;
  root.dataset.landscapeReady = 'true';
  const query = matchMedia('(min-width: 768px) and (max-width: 1100px) and (orientation: landscape)');
  const selectors = '.ub-pdp-feature-section,.ar-product-overview,.ar-product-specs,.ub-pdp-resources';
  const entries = [...root.children].filter(node => node.matches(selectors)).map(node => {
    const marker = document.createComment('Native product detail position');
    node.before(marker);
    return {node, marker};
  });
  const panel = document.createElement('div');
  panel.className = 'ub-landscape-details';
  panel.hidden = true;
  buy.append(panel);
  const move = (parent, node, before = null) => {
    if (parent.moveBefore) parent.moveBefore(node, before);
    else parent.insertBefore(node, before);
  };
  const updateHeader = () => {
    const rect = document.querySelector('.site-header')?.getBoundingClientRect();
    const bottom = rect ? Math.max(rect.height, rect.bottom) : 100;
    root.style.setProperty('--ub-product-header-offset', `${Math.ceil(bottom + 16)}px`);
  };
  const apply = () => {
    const focus = document.activeElement;
    const opened = [...root.querySelectorAll('.ub-feature-popover:popover-open')];
    root.classList.toggle('is-landscape-detail', query.matches);
    panel.hidden = !query.matches;
    for (const {node, marker} of entries) {
      if (query.matches) move(panel, node);
      else move(marker.parentNode, node, marker.nextSibling);
    }
    // Older browsers use insertBefore; restore an already-open feature panel.
    for (const popover of opened) {
      if (!popover.matches(':popover-open')) popover.showPopover();
    }
    if (focus?.isConnected && focus !== document.body) focus.focus({preventScroll:true});
    updateHeader();
  };
  query.addEventListener('change', apply);
  let scheduled = false;
  const scheduleHeader = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; updateHeader(); });
  };
  addEventListener('resize', scheduleHeader, {passive:true});
  addEventListener('scroll', scheduleHeader, {passive:true});
  const header = document.querySelector('.site-header');
  if (header && 'ResizeObserver' in window) new ResizeObserver(scheduleHeader).observe(header);
  apply();
})();
